/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Dashboard_Allocations_Ending_SoonInputs */

const en_admin_dashboard_allocations_ending_soon = /** @type {(inputs: Admin_Dashboard_Allocations_Ending_SoonInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} allocation ending soon`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} allocations ending soon`);
	return /** @type {LocalizedString} */ ("admin.dashboard.allocations_ending_soon");
};

const de_admin_dashboard_allocations_ending_soon = /** @type {(inputs: Admin_Dashboard_Allocations_Ending_SoonInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} Zuweisung endet bald`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} Zuweisungen enden bald`);
	return /** @type {LocalizedString} */ ("admin.dashboard.allocations_ending_soon");
};

const es_admin_dashboard_allocations_ending_soon = /** @type {(inputs: Admin_Dashboard_Allocations_Ending_SoonInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} asignación finalizando pronto`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} asignaciones finalizando pronto`);
	return /** @type {LocalizedString} */ ("admin.dashboard.allocations_ending_soon");
};

const fr_admin_dashboard_allocations_ending_soon = /** @type {(inputs: Admin_Dashboard_Allocations_Ending_SoonInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} attribution se termine bientôt`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} attributions se terminent bientôt`);
	return /** @type {LocalizedString} */ ("admin.dashboard.allocations_ending_soon");
};

const nl_admin_dashboard_allocations_ending_soon = /** @type {(inputs: Admin_Dashboard_Allocations_Ending_SoonInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} toewijzing eindigt binnenkort`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} toewijzingen eindigen binnenkort`);
	return /** @type {LocalizedString} */ ("admin.dashboard.allocations_ending_soon");
};

/** @type {(inputs: Admin_Dashboard_Allocations_Ending_SoonInputs) => LocalizedString} */
const it_admin_dashboard_allocations_ending_soon = en_admin_dashboard_allocations_ending_soon;

/** @type {(inputs: Admin_Dashboard_Allocations_Ending_SoonInputs) => LocalizedString} */
const pt_br2_admin_dashboard_allocations_ending_soon = en_admin_dashboard_allocations_ending_soon;

/** @type {(inputs: Admin_Dashboard_Allocations_Ending_SoonInputs) => LocalizedString} */
const pl_admin_dashboard_allocations_ending_soon = en_admin_dashboard_allocations_ending_soon;

/** @type {(inputs: Admin_Dashboard_Allocations_Ending_SoonInputs) => LocalizedString} */
const hu_admin_dashboard_allocations_ending_soon = en_admin_dashboard_allocations_ending_soon;

/** @type {(inputs: Admin_Dashboard_Allocations_Ending_SoonInputs) => LocalizedString} */
const ro_admin_dashboard_allocations_ending_soon = en_admin_dashboard_allocations_ending_soon;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} allocation ending soon" |
* | "other" | "{count} allocations ending soon" |
*
* @param {Admin_Dashboard_Allocations_Ending_SoonInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_allocations_ending_soon = /** @type {((inputs: Admin_Dashboard_Allocations_Ending_SoonInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Allocations_Ending_SoonInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_allocations_ending_soon(inputs)
	if (locale === "de") return de_admin_dashboard_allocations_ending_soon(inputs)
	if (locale === "es") return es_admin_dashboard_allocations_ending_soon(inputs)
	if (locale === "fr") return fr_admin_dashboard_allocations_ending_soon(inputs)
	if (locale === "nl") return nl_admin_dashboard_allocations_ending_soon(inputs)
	if (locale === "it") return it_admin_dashboard_allocations_ending_soon(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_allocations_ending_soon(inputs)
	if (locale === "pl") return pl_admin_dashboard_allocations_ending_soon(inputs)
	if (locale === "hu") return hu_admin_dashboard_allocations_ending_soon(inputs)
	return ro_admin_dashboard_allocations_ending_soon(inputs)
});
export { admin_dashboard_allocations_ending_soon as "admin.dashboard.allocations_ending_soon" }